import React from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo, this.props.fallback );
    }

    render() {
        if (this.state.hasError) {
            const { t } = this.props;
            return(<Container className="white-content d-flex flex-column justify-content-center align-items-center vh-100">
                <Row className="w-100">
                        <Col md={{ size: 6, offset: 3 }} className="text-center bg-light p-4 rounded shadow">
                        <h2>{t("error.apiError.title")}</h2>
                        <p>{this.props.fallback || <h1>Something went wrong.</h1> || t("error.apiError.message")}</p>
                        <Button color="primary" onClick={() => window.location.reload()} className="mt-3">
                            {t("error.action.retry", "Retry")}
                        </Button>
                        <div className="mt-4">
                                <Link to="/" className="btn btn-link">
                                {t("link.label.home")}
                                </Link>
                        </div>
                        </Col>
                </Row>
            </Container>)
        }

        return this.props.children;
    }
    }

    export default withTranslation()(ErrorBoundary);